import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import TextRow from '@/forms/FormElements/Rows/TextRow/TextRow.vue';

import RowValidationMixin from '@/forms/FormElements/Mixins/RowValidationMixin';

import { names } from './MessageRow.validation';

@Component({ components: { TextRow } })
export default class MessageRow extends mixins(RowValidationMixin) {
  names = names;
  
  @Prop({ type: String, default: null })
  readonly sublabel!: string;
  @Prop({ type: Number, default: 1000 })
  readonly maxLength!: number;
}
